import Image from 'next/image';
import { useEffect, useState } from 'react';
import AlertDialog from '../Utils/AlertDialog';
import axios from 'axios';
import { useRouter } from 'next/router';


const ContactUs = () => {
  const router = useRouter();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleSubmit = async () => {
    if (name === "") {
      setAlertMessage("Please fill in your name");
    } else if (email === "") {
      setAlertMessage("Please fill in your email");
    } else if (subject === "") {
      setAlertMessage("Please fill in the subject");
    } else if (message === "") {
      setAlertMessage("Please fill in the message");
    } else {
      try {
        const response = await axios.post(
          '/api/contact-us',
          {
            name: name,
            email: email,
            subject: subject,
            message: message
          }
        );

        if (response.data.status === "ok") {
          setAlertMessage("Your Email Has Been Sent! We will get back to you as soon as possible, please check your email for further notifications.");
          setName("");
          setEmail("");
          setSubject("");
          setMessage("");
        } else {
          setAlertMessage("Failed to send email. Please try again later.");
        }
      } catch (error) {
        setAlertMessage("Failed to send email. Please try again later.");
      }
    }
  }

  useEffect(() => {
    if (alertMessage !== "") {
      setOpen(true);
    }
  }, [alertMessage])

  useEffect(() => {
    if (!open) {
      setAlertMessage("");
    }
  }, [open])

  return (
    <div className="text-sm text-black font-poppins">
      <div
        className="container flex items-center mt-4 mb-6 space-x-4 md:hidden"
        onClick={() => router.back()}
      >
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/arrow-down.png"}
          alt="arrow icon"
          width={12}
          height={12}
          quality={100}
          className={`transition-transform ease-in-out duration-300 transform rotate-90`}
        />
        <p className="text-base font-bold leading-5 text-black">Contact US</p>
      </div>
      <div className="md:hidden">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/contact-us-mb.jpg"}
          alt="contact us image"
          quality={100}
          width={576}
          height={157}
          className="w-full"
        />
      </div>
      <div className="hidden md:block">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/contact-us-pc.jpg"}
          alt="contact us image"
          width={1200}
          height={200}
          quality={100}
          className="w-full"
        />
      </div>
      <div className="w-full grid gird-cols-1 md:grid-cols-2 gap-6 mb-[69px] md:mb-10 mt-6">
        <div className="px-6">
          <p className="text-base font-bold leading-6">MOOIMOM Customer Service</p>
          <p className="mt-4 font-bold leading-6">OPERATIONAL TIME</p>
          <p className="mt-2 font-normal leading-6">Monday - Friday<br />09.30 - 17.30</p>
          <hr className="my-8 bg-reviewBg" />
          <p className="font-bold leading-6">Contact us at</p>
          <div className="grid grid-cols-2 mt-4 gap-x-2 gap-y-4">
            <div className="flex items-center space-x-2">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/social/tiff-circle-wa.png"}
                alt="whatsapp icon"
                quality={100}
                width={20}
                height={20}
              />
              <p>+62-812-8844-6533</p>
            </div>
            <div className="flex items-center space-x-2">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/social/tiff-circle-mail.png"}
                alt="email icon"
                quality={100}
                width={20}
                height={20}
              />
              <p>cs@mooimom.id</p>
            </div>
            <div className="flex items-center space-x-2">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/social/tiff-circle-ig.png"}
                alt="instagram icon"
                quality={100}
                width={20}
                height={20}
              />
              <p>@mooimom.id</p>
            </div>
            <div className="flex items-center space-x-2">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/social/tiff-circle-line.png"}
                alt="line icon"
                quality={100}
                width={20}
                height={20}
              />
              <p>@mooimom</p>
            </div>
          </div>
        </div>
        <div className="px-6 mt-8 md:mt-0">
          <h1 className="text-base font-bold leading-6">We Would Like To Hear From You</h1>
          <p className="mt-4 leading-6">We love hearing from you. Let us know how we can help you better.</p>
          <input
            type="text"
            name="name"
            value={name}
            placeholder="Name"
            className="w-full px-8 py-4 mt-6 text-sm border outline-none placeholder:text-sku border-sku focus:ring-transparent"
            onChange={event => setName(event.target.value)}
          />
          <input
            type="input"
            name="email"
            value={email}
            placeholder="Email"
            className="w-full px-8 py-4 mt-6 text-sm border outline-none placeholder:text-sku border-sku focus:ring-transparent focus:border-sku"
            onChange={event => setEmail(event.target.value)}
          />
          <input
            type="input"
            name="subject"
            value={subject}
            placeholder="Subject"
            className="w-full px-8 py-4 mt-6 text-sm border outline-none placeholder:text-sku border-sku focus:ring-transparent"
            onChange={event => setSubject(event.target.value)}
          />
          <textarea
            rows={5}
            name="message"
            value={message}
            placeholder="Message"
            className="w-full px-8 py-4 mt-6 text-sm border outline-none placeholder:text-sku border-sku focus:ring-transparent"
            onChange={event => setMessage(event.target.value)}
          ></textarea>
          <div className="flex justify-center md:justify-start">
            <button
              className="px-6 py-3 mt-6 text-base font-medium text-center text-white rounded-lg bg-mooimom"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
        <AlertDialog
          open={open}
          setOpen={setOpen}
          message={alertMessage}
        />
      </div>
    </div>
  )
}

export default ContactUs
